import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { PreparedStarterInfo } from '@racemap/utilities/functions/timing';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { pulsate } from 'src/lib/keyframes';
import type { Column } from '../TableBody';
import { Cell } from './BasicCell';

interface Props {
  starterInfo: Immutable<PreparedStarterInfo>;
}

const LiveStateColComponent: FC<Props> = ({ starterInfo }) => {
  return (
    <StyledCell>
      {starterInfo.online && <RingRing />}
      <Circle title="live" online={starterInfo.online} data-toggle="tooltip" data-placement="top" />
    </StyledCell>
  );
};

export function getLiveStateCol(): Column {
  return {
    key: 'live',
    title: 'Live',
    width: 40,
    sorter: (a: Immutable<PreparedStarterInfo>, b: Immutable<PreparedStarterInfo>) =>
      Number(b?.online) - Number(a?.online),
    render: function renderer(row: Immutable<PreparedStarterInfo>) {
      return <LiveStateColComponent starterInfo={row} />;
    },
  };
}

const StyledCell = styled(Cell)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RingRing = styled.div`
  border: 3px solid ${RacemapColors.LightGreen};
  border-radius: 30px;
  height: 20px;
  width: 20px;
  position: absolute;
  animation: ${pulsate(0.9)} 2s ease-out infinite;
  opacity: 0;
`;

const Circle = styled.div<{ online: boolean }>`
  width: 10px;
  height: 10px;
  background-color: ${(props) => (props.online ? RacemapColors.BaseGreen : RacemapColors.LightGray)};
  border-radius: 50%;
  position: absolute;
`;
